var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 119.7 119.9",
    background: "new 0 0 119.7 119.9",
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8D9296",
    d: "M45.8,118.5C23.9,113.1,6.4,95.4,1.2,73.4c-2.1-9.1-1.5-23.5,1.5-32.6C7.2,26.8,19.2,13.1,33.1,6         c15.3-7.8,35.8-8.1,52-0.6c10.9,5,22.9,16.4,28.4,27c5.7,11.1,7.8,28.5,4.9,40.9c-6.6,27.8-30.7,46.8-59.1,46.6         C54.9,119.9,48.8,119.2,45.8,118.5z M52.5,74.8l7.2-7.2l7.5,7.2c7.4,7.2,10.7,8.7,13.4,6c2.8-2.8,1.3-6.2-6-13.5L67.4,60l7.2-7.3         c7.3-7.3,8.8-10.7,6-13.5c-2.8-2.8-6.2-1.3-13.5,6l-7.3,7.2l-7.3-7.2c-7.3-7.3-10.7-8.8-13.5-6c-2.8,2.8-1.3,6.2,6,13.5l7.2,7.3         L45,67.3c-7.3,7.3-8.8,10.7-6,13.5S45.2,82.1,52.5,74.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/clear_icon.6903166e.svg";
export { ForwardRef as ReactComponent };